import { render, staticRenderFns } from "./DelItemDialog.vue?vue&type=template&id=596e45d4&scoped=true&"
import script from "./DelItemDialog.vue?vue&type=script&lang=js&"
export * from "./DelItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./DelItemDialog.vue?vue&type=style&index=0&id=596e45d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e45d4",
  null
  
)

export default component.exports